import * as Dtype from "./dtype.bs.js";

function data(prim) {
  return prim.data;
}

function size(prim) {
  return prim.size;
}

function order(prim) {
  return prim.order;
}

function dtype(t) {
  return Dtype.wrap(t.dtype);
}

function shape(prim) {
  return prim.shape;
}

function stride(prim) {
  return prim.stride;
}

function offset(prim) {
  return prim.offset;
}

function dimension(prim) {
  return prim.dimension;
}

export { data, size, order, dtype, shape, stride, offset, dimension };
/* No side effect */